<!-- Loader -->
@if (loading) {
  <div class="absolute inset-x-0 bottom-0">
    <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
  </div>
}

@if (!loading) {
  @if (!data) {
    <div class="p-4 flex flex-row flex-wrap">{{ 'dbTables.noData' | transloco }}</div>
  }
  @if (data) {
    <div>
      <div class="p-2 pb-4 flex">
        <button mat-raised-button color="primary" class="p-4 mr-4" (click)="showRequest()" [disabled]="!data?.dtypeToGoLiveRequest">
          <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color text-on-primary" aria-hidden="true"[svgIcon]="'heroicons_solid:information-circle'"></mat-icon>
          <span class="pl-1">{{ 'dbTables.requestReview' | transloco}}</span>
        </button>
        <button mat-raised-button class="p-4 mr-4 bg-green-600 dark:bg-green-800 text-white" (click)="accept()">
          <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
          <span class="pl-1">{{ 'dbTables.acceptChanges' | transloco}}</span>
        </button>
        <button mat-raised-button color="warn" class="p-4 mr-4" (click)="reject()">
          <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color text-on-warn" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
          <span class="pl-1">{{ 'dbTables.denyChanges' | transloco}}</span>
        </button>
      </div>
      <ng-container *ngTemplateOutlet="compareTables"></ng-container>
    </div>
  }
}

<ng-template #compareTables>
  @for (comparison of drawQuarantineTables; track comparison; let i = $index) {
    <div class="p-2 flex place-content-center text-2xl font-bold">{{ comparison.title }}</div>
    @if (comparison?.tableComparison) {
      <div class="p-2 pl-4 text-lg">{{ 'dbTables.buttons.result' | transloco }} {{ comparison.tableComparison }}</div>
    }
    @if (comparison?.buttons?.message) {
      <div class="p-2 pl-4 text-lg">{{ 'dbTables.buttons.description' | transloco }} {{ comparison.buttons.message }}</div>
    }
    <div class="p-2 pl-4 flex flex-row items-center">
      @if (comparison?.buttons?.design?.show || comparison?.buttons?.compatible?.show) {
        <span class="text-lg">{{ 'dbTables.buttons.action' | transloco }}</span>
      }
      @if (comparison?.buttons?.design?.show) {
        <button class="ml-2" mat-flat-button
          [ngClass]="{'bg-green-600 dark:bg-green-800 text-white': $safeNavigationMigration(comparison?.buttons?.design?.selected), 'bg-gray-200 dark:bg-gray-700': !comparison?.buttons?.design?.selected}"
          (click)="checkButton(i, 'design')" [matTooltip]="comparison?.buttons?.design?.info ? $safeNavigationMigration(comparison?.buttons?.design?.info) : null">
          {{ comparison.buttons.design.caption }}
        </button>
      }
      @if (comparison?.buttons?.compatible?.show) {
        <button class="ml-2" mat-flat-button
          [ngClass]="{'bg-green-600 dark:bg-green-800 text-white': $safeNavigationMigration(comparison?.buttons?.compatible?.selected), 'bg-gray-200 dark:bg-gray-700': !comparison?.buttons?.compatible?.selected}"
          (click)="checkButton(i, 'compatible')" [matTooltip]="comparison?.buttons?.compatible?.info ? $safeNavigationMigration(comparison?.buttons?.compatible?.info) : null">
          {{ comparison.buttons.compatible.caption }}
        </button>
      }
      @if (comparison?.buttons?.migrate?.show) {
        <mat-checkbox class="ml-2" [(ngModel)]="comparison.buttons.migrate.selected">
          {{ comparison.buttons.migrate.caption }}
        </mat-checkbox>
      }
    </div>
    <div class="p-2 grid grid-flow-row grid-cols-3 flex-wrap">
      @if (comparison?.design) {
        <dtype-quarantine-table class="flex flex-col p-2 w-full" [table]="$safeNavigationMigration(comparison?.design)"></dtype-quarantine-table>
      }
      @if (comparison?.live) {
        <dtype-quarantine-table class="flex flex-col p-2 w-full" [table]="$safeNavigationMigration(comparison?.live)"></dtype-quarantine-table>
      }
      @if (comparison?.bestCompatible) {
        <dtype-quarantine-table class="flex flex-col p-2 w-full" [table]="$safeNavigationMigration(comparison?.bestCompatible)"></dtype-quarantine-table>
      }
    </div>
    <mat-divider class="mb-2"></mat-divider>
  }

</ng-template>